import * as React from 'react'
import Table from '@components/table/table'
import { getTechnicalOrderStatusColor } from '@modules/technical-orders/helpers'
import classNames from 'classnames'
import { TechnicalOrder } from '@models/technical-orders'

interface Props {
  technicalOrder: TechnicalOrder
}

export const TechnicalOrdersTodoRowStatus: React.FC<Props> = ({ technicalOrder }) => (
  <Table.Cell className="vertical-align-middle" style={{ width: 100 }}>
    <span className={classNames('badge text-lowercase', `badge-${getTechnicalOrderStatusColor(technicalOrder)}`)}>
      {technicalOrder.status_display}
    </span>
  </Table.Cell>
)
